module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Medium-WebS.573bd0b4.woff";